import React from 'react';
import axios from "axios";

import DialogOk from 'Components/Dialog/DialogOk';
import DialogYesNo from 'Components/Dialog/DialogYesNo';
import HintToMembers from 'Components/App/HintToMembers';
import Login from 'Components/Member/Login';
import Modal from 'Components/Core/Modal';
import NavigationTop from 'Components/App/NavigationTop';
import NavigationLeft from 'Components/App/NavigationLeft';
import MemberList from 'Components/Member/MemberList';
import Topics from 'Components/Forum/Topics';
import Foren from 'Components/Forum/Foren';
import Pages from 'Components/PageStore/Pages';
import Sections from 'Components/PageStore/Sections';
import PageStoreGenerator from 'Components/PageStore/PageStoreGenerator';
import PollAdmin from 'Components/Poll/PollAdmin';
import Polls from 'Components/Poll/Polls';
import PollHintDialog from 'Components/Poll/PollHintDialog';
import ShareTargetDialog from 'Components/App/ShareTargetDialog';
import BankAccounts from 'Components/Banking/BankAccounts';
import BankTransactions from 'Components/Banking/BankTransactions';
import BrokerageOverview from 'Components/Banking/BrokerageOverview';
import BrokerageOrderbook from 'Components/Banking/BrokerageOrderbook';
import IbBrokerageOverview from 'Components/Banking/IbBrokerageOverview';
import IbBrokerageOrderbook from 'Components/Banking/IbBrokerageOrderbook';
import BrokerageOrderTemplates from 'Components/Banking/BrokerageOrderTemplates';
import Rezepte from 'Components/Rezepte/Rezepte';
import RezeptKategorien from 'Components/Rezepte/RezeptKategorien';
import MarketdataWatchlist from 'Components/Marketdata/MarketdataWatchlist';
import MarketdataQuotes from 'Components/Marketdata/MarketdataQuotes';
import MarketdataCharts from 'Components/Marketdata/MarketdataCharts';
import IbGatewayControl from 'Components/Marketdata/IbGatewayControl';
import Smilies from 'Components/Forum/Smilies';
import Forum from 'Components/Forum/Forum';
import Settings from 'Components/Member/Settings';
import PhpInfo from 'Components/Admin/PhpInfo';
import PushSubscriptions from 'Components/Admin/PushSubscriptions';
import ForumOptions from 'Components/Admin/ForumOptions';
import SystemInfo from 'Components/App/SystemInfo';

export default function Content(props) {

	const x = props.x;
	const io = window.io;

	const conRef = React.useRef(null);
	const webAppRenderd = React.useRef(false);

	const [forumUnread, setForumUnread] = React.useState(0);
	const renderCount = React.useRef(1);

	const [dialog, setDialog] = React.useState([]);
	const [hint, setHint] = React.useState([]);
	const [module, setModule] = React.useState([]);
	const [navigation, setNavigation] = React.useState([]);

	let connection = conRef.current;

	React.useEffect(() => {
		x.was.addHint = addHint;
		x.was.addModule = addModule;
		x.was.addNavigation = addNavigation;
		x.was.getMemberList = getMemberList;
		x.was.removeDialog = removeDialog;
		x.was.removeHint = removeHint;
		x.was.removeModule = removeModule;
		if (renderCount.current === 1) {
			x.was.send = socketSend;
			socketConnect();
		}
		renderCount.current++;
		if (props.webAppReady) {
			if (!webAppRenderd.current) {
				if (props.login === true) {
					webAppRenderd.current = true;
					// addModule(<Login id="login" x={x} formId="login" title="Login" />)
				}
				else {
					x.was.webapp = 1;
					init();
					makeContent();
					webAppRenderd.current = true;
					// Erst hier ist x.wam.tags wirklich befuellt (siehe init()/makeContent()
					// oben) - ein Aufruf ueber ein geratenes setTimeout(0) in Webapp.js waere
					// auf langsameren Geraeten nicht zuverlaessig (stiller No-op, falls das
					// Tag noch fehlt).
					if (typeof props.onReady === 'function') props.onReady();
				}
			}
		}
	});

	async function getMemberList(orderField) {
		const getData = async (orderField) => {
			const url = 'Backend/webapp.php?module=Member&task=MemberList&active=1' + ((orderField === '') ? '' : '&order-field=' + orderField);
			const result = await axios.get(url);
			return result;
		}
		const result = await getData(orderField)
		if (result.data['returncode'] === 1) {
			setForumUnread(result.data.content[0].postingsunread);			
		}
		return result;
	}


	function socketConnect() {

		connection = io(document.location.href, { path: "/Websocket/" });
		x.was.webSocket = connection;
		
		connection.on('hint', (args) => {
			args = JSON.parse(args);
			x.wah.addHint(args.hint);
			return true;
		});

		// Marktdaten-Warnung (Chat vom 2026-08-10, IB-Line-Limit-Watcher) -
		// serverseitig als Objekt emittiert (nicht als JSON-String, siehe
		// socketServer.mjs::io.emit('marketdata-alert', ...)), daher KEIN
		// JSON.parse. Kein Auto-Close (false), da die Info wichtig ist und in
		// Ruhe gelesen werden soll. Global hier, damit sie unabhaengig vom
		// gerade offenen Modul erscheint.
		connection.on('marketdata-alert', (payload) => {
			if (payload && payload.text) {
				x.wah.addHint(payload.text, false);
			}
			return true;
		});
		
		connection.on('new-posting', (args) => {
			args = JSON.parse(args);
			if (typeof x.wam[args.module] !== 'undefined') {
				// x.wam[args.module].updatePostingsUnread(9);
				x.wam[args.module].reload();
			}
			x.was.loadActiveMember();
		});

		connection.on('typing', (args) => {
			args = JSON.parse(args);
			if (args.memberid !== x.was.memberId) {
				if (typeof x.was.setMemberTyping !== 'undefined') {
					x.was.setMemberTyping(args.memberid);
				}
				if (args.forumId && typeof x.wam[args.forumId] !== 'undefined' && typeof x.wam[args.forumId].setTyping !== 'undefined') {
					x.wam[args.forumId].setTyping(args.member);
				}
			}
		});

		connection.on('read-posting', (args) => {
			args = JSON.parse(args);
			if (args.memberid === x.was.memberId) {
				console.log('Read Posting...');
				x.was.loadActiveMember();
				if (typeof x.wam[args.module] !== 'undefined') {
					x.wam[args.module].reload();
				}
			}
		});
	
	
		connection.on('login', (args) => {
			args = JSON.parse(args);
			x.was.loadActiveMember();
		});

		connection.on('logout', (args) => {
			args = JSON.parse(args);
			x.was.loadActiveMember();
		});

		connection.on('update', (args) => {
			console.log('Update Member...');
			/* 
			const dregg = new Error('I was called').stack;
			const stack = dregg.split('\n');
			console.log(dregg);
			console.log(stack[0]);
			console.log(stack[2]);
			*/
		});

		connection.on('smilies-update', (args) => {
			x.was.axGet('/Backend/webapp.php?module=System&task=ReloadSessionData', (result) => {
				x.was.setSmilies(result.data.content.smilies);
			});
		});

		connection.on('software-update', (args) => {
			localStorage.setItem('software-update', 1);
			window.location.reload();
		});

		connection.on('ping', (args) => {
			console.log('Ping.....' + args);
			return true;
		});
		
		connection.on('connect', (args) => {
			console.log('Connect...');
			x.wam.reloadForums();
			x.was.loadActiveMember();
			// Deckt den Fall ab, dass eine neue Umfrage angelegt wurde, waehrend
			// dieser Tab schon offen war (makeContent()/loadPendingPolls() laueft
			// sonst nur einmal pro komplettem Seitenaufbau, siehe webAppRenderd-
			// Guard oben) - ein Reconnect (z.B. nach kurzem Verbindungsabbruch,
			// oder socket.io's initialer 'connect' selbst) stoesst den Check erneut an.
			if (typeof x.was.loadPendingPolls === 'function') x.was.loadPendingPolls();
		});

		connection.on('disconnect', (args) => {
			console.log('Disconnect...');
		});

	}

	function socketSend(type, args, handleResult = false) {
		args.member = x.was.memberName;
		args.memberid = x.was.memberId;
		// console.log(args);
		try {
			if (handleResult === false) {
				connection.emit(type, JSON.stringify(args));				
			}
			else {
				connection.emit(type, JSON.stringify(args), (response) => {
					// console.log('Response: ' + response);
					handleResult(JSON.parse(response));
				});
			}
		} catch (error) {
			console.log('socket.io error');
		}
	}

	function addDialog(obj) {
		x.wad.init(obj.props.id);
		obj = { tag: obj };
		setDialog(current => [...current, obj]);
	};

	function addHint(obj) {
		obj = { tag: obj };
		setHint(current => [...current, obj]);
	};

	const addModule = (obj) => {
		x.wam.init(obj.props.id);
		x.wam.current = obj.props.id;
		obj = { tag: obj };
		setModule(current => [...current, obj]);
	};

	const addNavigation = (obj) => {
		obj = { tag: obj };
		setNavigation(current => [...current.filter(item => item.tag.props.id !== obj.tag.props.id), obj]);
	};


	function removeDialog(id) {
		delete x.wad[id];
		setDialog(prev => prev.filter(moduleTag => moduleTag.tag.props.id !== id))
	}

	function removeHint(id) {
		delete x.wah[id];
		setHint(prev => prev.filter(hintTag => hintTag.tag.props.id !== id))
	}

	function removeModule(id) {
		x.wam[id].onClose();
		delete x.wam[id];
		delete x.was.postingsUnread[id];
		setModule(prev => prev.filter(moduleTag => moduleTag.tag.props.id !== id))
		// console.log(x.wam);
	}



	function init() {
		// Dialog-Definition
		x.wad.addTag(<DialogOk id="ok" x={x} />);
		x.wad.addTag(<DialogYesNo id="yesno" x={x} />);
		x.wad.addTag(<PollHintDialog id="poll-hint" x={x} />);
		x.wad.addTag(<ShareTargetDialog id="share-target" x={x} />);

		// Modul-Definition
		// Titel wie in der Sidebar/im Dropdown (NavigationSearch.js) der
		// Instanz-Name statt hart "Hauptforum" - siehe dort fuer denselben Fix.
		x.wam.addTag(<Forum id="forum" forumId="forum" x={x} forum={true} title={x.was.application} display="d-none" />);
		x.wam.addTag(<Forum id="admin" forumId="admin" x={x} forum={true} title={'Admin-Forum'} display="d-none" />);
		// x.wam.addTag(<Test id="test" x={x} title="Test" />);
		// x.wam.addTag(<Forum id="forum-admin" x={x} title="Admin-Forum" display="d-none" />);
		x.wam.addTag(<Smilies id="smilies" x={x} title="Smilies" display="d-box" />);
		x.wam.addTag(<Foren id="foren" x={x} title="Foren" display="d-box" />);
		x.wam.addTag(<Topics id="topics" x={x} title="Themen" display="d-box" />);
		x.wam.addTag(<MemberList id="member-list" x={x} active={false} title="Mitgliederliste" display="d-box" />);
		x.wam.addTag(<SystemInfo id="system-info" x={x} title="System-Information" display="d-box" />);
		x.wam.addTag(<HintToMembers id="hint-to-members" x={x} title="Nachricht an alle" display="d-box" />);
		x.wam.addTag(<PageStoreGenerator id="page-store-generator" x={x} title="Meine Seite" display="d-box" />);
		x.wam.addTag(<Sections id="sections" x={x} title="Page Store Rubriken" display="d-box" />);
		x.wam.addTag(<Pages id="pages" x={x} title="Page Store Seiten" display="d-box" />);
		x.wam.addTag(<PollAdmin id="poll-admin" x={x} title="Umfragen-Verwaltung" display="d-box" />);
		x.wam.addTag(<Polls id="polls" x={x} title="Umfragen" display="d-box" />);
		x.wam.addTag(<BankAccounts id="bank-accounts" x={x} title="Banking Konten" display="d-box" />);
		x.wam.addTag(<BankTransactions id="bank-transactions" x={x} title="Banking Umsätze" display="d-box" />);
		x.wam.addTag(<BrokerageOverview id="brokerage-overview" x={x} title="Comdirect-Depot" display="d-box" />);
		x.wam.addTag(<BrokerageOrderbook id="brokerage-orderbook" x={x} title="Orderbuch" display="d-box" />);
		x.wam.addTag(<BrokerageOrderTemplates id="brokerage-order-templates" x={x} title="Ordervorlagen" display="d-box" />);
		// IB-Brokerage (Chat vom 2026-08-07, Phase 2 der IBKR-Integration) -
		// eigenstaendiges Modul neben Comdirect, siehe IbBrokerageOverview.js.
		x.wam.addTag(<IbBrokerageOverview id="ib-brokerage-overview" x={x} title="IB-Depot" display="d-box" />);
		x.wam.addTag(<IbBrokerageOrderbook id="ib-brokerage-orderbook" x={x} title="IB-Orderbuch" display="d-box" />);
		x.wam.addTag(<Rezepte id="rezepte" x={x} title="Rezepte" display="d-box" />);
		x.wam.addTag(<RezeptKategorien id="rezept-kategorien" x={x} title="Rezept-Kategorien" display="d-box" />);
		x.wam.addTag(<MarketdataWatchlist id="marketdata-watchlist" x={x} title="Watchlist" display="d-box" />);
		x.wam.addTag(<MarketdataQuotes id="marketdata-quotes" x={x} title="Watchlist Live" display="d-box" />);
		x.wam.addTag(<MarketdataCharts id="marketdata-charts" x={x} title="Charts" display="d-box" />);
		x.wam.addTag(<IbGatewayControl id="ib-gateway-control" x={x} title="IB-Gateway-Steuerung" display="d-box" />);
		x.wam.addTag(<Settings id="settings" x={x} title="Einstellungen" display="d-box" />);
		x.wam.addTag(<PhpInfo id="php-info" x={x} title="PHP-Info" display="d-box" />);
		x.wam.addTag(<PushSubscriptions id="push-subscriptions" x={x} title="Push-Subscriptions" display="d-box" />);
		x.wam.addTag(<ForumOptions id="forum-options" x={x} title="Instanz-Verwaltung" display="d-box" />);
	}

	function makeContent() {
		// Erzeuge Dialoge
		addDialog(x.wad.tags['ok']);
		addDialog(x.wad.tags['yesno']);
		addDialog(x.wad.tags['poll-hint']);
		addDialog(x.wad.tags['share-target']);
		// addDialog(x.wad.tags['dialog-form']);

		// Erzeuge Module
		if (x.was.isAdmin() && x.was.adminForum) addModule(x.wam.tags['admin']);
		addModule(x.wam.tags['forum']);

		// Hint-Dialog fuer offene Umfragen einmal pro Forumsbesuch abfragen -
		// setTimeout(0), da x.was.loadPendingPolls erst gesetzt ist, nachdem
		// PollHintDialog (oben per addDialog) tatsaechlich gerendert wurde.
		setTimeout(() => { if (typeof x.was.loadPendingPolls === 'function') x.was.loadPendingPolls(); }, 0);
	}

	return (
			(props.webAppReady) 
				?
					<div key="content" id="content">
						<Modal id="modal" x={x} />
						{(props.login === false) 
							?
								<>
									<NavigationLeft id="navigation-left" x={x} />
									<NavigationTop id="navigation-top" forum={true} x={x} forumUnread={forumUnread} />
								</>
							:	
								<Login id="login" x={x} formId="login" title="Login" />							
						}
						{dialog.map(({ tag, id }) =>
							<React.Fragment key={"dialog-" + tag.props.id}> {tag}</React.Fragment>
						)}
						<div key="hint" id="hint" className="hint-frame" >
							{hint.map(({ tag, id }) =>
								<React.Fragment key={"hint-" + tag.props.id}> {tag}</React.Fragment>
							)}
						</div>
						{navigation.map(({ tag, id }) =>
							<React.Fragment key={"navigation-" + tag.props.id}> {tag}</React.Fragment>
						)}
						<div key="module" id="module" className="flex-fill overflow-hidden" >
							{module.map(({ tag, id }) =>
								<React.Fragment key={"module-" + tag.props.id}>
									{(tag.props.forum === true) ? React.cloneElement(tag, { updateForum: props.renderForum }) : tag}
								</React.Fragment>
							)}
						</div>
					</div>
			:
					null
	);
}
